import { BehaviorSubject, Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { BaseCommunication } from "@app/core/shared/domain/base.comunication";
import { Wallet } from "@app/core/wallet/domain/model/wallet";

@Injectable({ providedIn: "root" })
export class WalletCommunication implements BaseCommunication<Wallet> {
  communication = new BehaviorSubject<Wallet | null>(null);

  write(wallet: Wallet): void {
    this.communication.next(wallet);
  }
  listen(): Observable<Wallet | null> {
    return this.communication.asObservable();
  }
}
